import { oz } from '@weft/utils';
import type { ZapiParam } from '@weft/zapi-types';

export const SEARCH_QUERY_PARAMETER = {
  name: 'search',
  location: 'query',
  schema: oz.string().nonempty().optional(),
  required: false,
} as const satisfies ZapiParam;